import WsProvider from './provider/WSProvider'

var base64 = require('base64_js');

var serviceName = "index";
var urunService = {
    imageUrlBuyuk: WsProvider.resim + "/HBT0082/buyuk/",
    imageUrlOrta: WsProvider.resim + "/HBT0082/orta/",
    imageUrlKucuk: WsProvider.resim + "/HBT0082/kucuk/",
    imageUrlEnKucuk: WsProvider.resim + "/HBT0082/enkucuk/",
    path: "https://www.kaderfood.ch/",
    kategoriTree() {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                serviceName: "urun",
                methodName: "urunKategoriTree"
            }
        };
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    ukategoriTanimlama(ustKategori, link, baslik, altBaslik, icerik, seoBaslik, seoIcerik, resimList, icon, renk, durum, dil) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                ustKategori: ustKategori,
                link: link,
                baslik: baslik,
                altBaslik: altBaslik,
                icerik: icerik,
                seoBaslik: seoBaslik,
                seoIcerik: seoIcerik,
                resimList: resimList,
                icon: icon,
                renk: renk,
                durum: durum,
                dil: dil,
                serviceName: "urun",
                methodName: "ukategoriTanimlama"

            }
        };
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    ukategoriList(durum, dil) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                durum: durum,
                dil: "tr",
                serviceName: "urun",
                methodName: "ukategoriList"

            }
        };
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    ukategoriDetay(ukategoriId) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                ukategoriId: ukategoriId,
                serviceName: "urun",
                methodName: "ukategoriDetay"

            }
        };
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    ukategoriGuncelle(ukategoriId, updateList) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                ukategoriId: ukategoriId,
                updateList: updateList,
                serviceName: "urun",
                methodName: "ukategoriGuncelle"

            }
        };
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    ukategoriDurumGuncelle(ukategoriId, durum) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                ukategoriId: ukategoriId,
                durum: durum,
                serviceName: "urun",
                methodName: "ukategoriDurumGuncelle"

            }
        };
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    urunCount(durum) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                durum: durum,
                serviceName: "urun",
                methodName: "urunCount"

            }
        };
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    urunTanimlama(urunKodu, link, baslik, altBaslik, icerik, fiyat, eskiFiyat, seoBaslik, seoIcerik, resimList, durum, dil, kategoriList, opsiyonList, malzemeList, cikarilacaklar) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                urunKodu: urunKodu,
                link: link,
                baslik: baslik,
                altBaslik: altBaslik,
                icerik: icerik,
                fiyat: fiyat,
                eskiFiyat: eskiFiyat,
                seoBaslik: seoBaslik,
                seoIcerik: seoIcerik,
                resimList: resimList,
                durum: durum,
                dil: dil,
                kategoriList: kategoriList,
                opsiyonList: opsiyonList,
                malzemeList: malzemeList,
                malzemeList2: cikarilacaklar,
                serviceName: "urun",
                methodName: "urunTanimlama2"

            }
        };
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    urunKategoriAtama(urunKodu, kategoriList) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                urunKodu: urunKodu,
                kategoriList: kategoriList,
                serviceName: "urun",
                methodName: "urunKategoriAtama"

            }
        };
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    urunDetay(urunId) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                urunId: urunId,
                dil: "tr",
                serviceName: "urun",
                methodName: "urunDetay"

            }
        };
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                console.log("urundetay =>>>>", response.data)
                resolve(response)
            })
        });
        return result;

    },


    urunListesi(durum, baslangic, limit) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                durum: durum,
                dil: "tr",
                baslangic: baslangic,
                limit: limit,
                serviceName: "urun",
                methodName: "urunTumListesi"

            }
        };
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    kategoriUrunList(ukategoriId, dil) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                ukategoriId: ukategoriId,
                dil: "tr",
                serviceName: "urun",
                methodName: "kategoriUrunList"

            }
        };
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    urunDurumGuncelle(urunId, durum) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                urunId: urunId,
                durum: durum,
                serviceName: "urun",
                methodName: "urunDurumGuncelle"

            }
        };
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    urunOnlineSatisDurumGuncelle(urunId) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                urunId: urunId,
                serviceName: "urun",
                methodName: "urunOnlineSatis"

            }
        };
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    urunGuncelle(urunId, updateList) {
        //console.log("urun güncelle updateList: ", updateList)
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                urunId: urunId,
                updateList: updateList,
                serviceName: "urun",
                methodName: "urunGuncelle"

            }
        };
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    urunOpsiyonGuncelle(urunId, updateList) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                urunId: urunId,
                updateList: updateList,
                serviceName: "urun",
                methodName: "urunOpsiyonGuncelle"
            }
        };
        var result = new Promise(function(resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    urunMalzemeGuncelle(urunId, updateList) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                urunId: urunId,
                updateList: updateList,
                serviceName: "urun",
                methodName: "urunMalzemeGuncelle"
            }
        };
        var result = new Promise(function(resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    urunCikarilacakMalzemeGuncelle(urunId, updateList) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                urunId: urunId,
                updateList: updateList,
                serviceName: "urun",
                methodName: "urunCikarilacakMalzemeGuncelle"
            }
        };
        var result = new Promise(function(resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    urunKategoriGuncelle(urunId, updateList) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                urunId: urunId,
                updateList: updateList,
                serviceName: "urun",
                methodName: "urunKategoriGuncelle"
            }
        };
        var result = new Promise(function(resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    uopsiyonTanimlama(baslik, yapiskan, konum, durum, dil, kategoriList) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                baslik: baslik,
                yapiskan: yapiskan,
                konum: konum,
                durum: durum,
                dil: "tr",
                kategoriList: kategoriList,
                serviceName: "urun",
                methodName: "uopsiyonTanimlama"

            }
        };
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    uopsiyonList(durum, baslangic, limit) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                dil: "",
                durum: durum,
                baslangic: baslangic,
                limit: limit,
                serviceName: "urun",
                methodName: "uopsiyonList"

            }
        };
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    uopsiyonDetay(uopsiyonId) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                uopsiyonId: uopsiyonId,
                serviceName: "urun",
                methodName: "uopsiyonDetay"

            }
        };
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    uopsiyonGuncelle(uopsiyonId, updateList) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                uopsiyonId: uopsiyonId,
                updateList: updateList,
                serviceName: "urun",
                methodName: "uopsiyonGuncelle"

            }
        };
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    urunOpsiyonKategoriGuncelle(uopsiyonId, updateList) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                uopsiyonId: uopsiyonId,
                updateList: updateList,
                serviceName: "urun",
                methodName: "urunOpsiyonKategoriGuncelle"
            }
        };
        var result = new Promise(function(resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    uopsiyonDurumGuncelle(uopsiyonId, durum) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                uopsiyonId: uopsiyonId,
                durum: durum,
                serviceName: "urun",
                methodName: "uopsiyonDurumGuncelle"

            }
        };
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    umalzemeTanimlama(baslik, fiyat, ucretDurum, kategoriList, durum, dil) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                baslik: baslik,
                fiyat: fiyat,
                ucretDurum: ucretDurum,
                kategoriList: kategoriList,
                durum: durum,
                dil: "tr",
                serviceName: "urun",
                methodName: "umalzemeTanimlama"

            }
        };
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    umalzemeList(durum, baslangic, limit) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                dil: "",
                durum: durum,
                baslangic: baslangic,
                limit: limit,
                serviceName: "urun",
                methodName: "umalzemeList"

            }
        };
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    umalzemeDetay(umalzemeId) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                umalzemeId: umalzemeId,
                serviceName: "urun",
                methodName: "umalzemeDetay"

            }
        };
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    urunMalzemeKategoriGuncelle(umalzemeId, updateList) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                umalzemeId: umalzemeId,
                updateList: updateList,
                serviceName: "urun",
                methodName: "urunMalzemeKategoriGuncelle"
            }
        };
        var result = new Promise(function(resolve) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    umalzemeGuncelle(umalzemeId, updateList) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                umalzemeId: umalzemeId,
                updateList: updateList,
                serviceName: "urun",
                methodName: "umalzemeGuncelle"

            }
        };
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    umalzemeDurumGuncelle(umalzemeId, durum) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                umalzemeId: umalzemeId,
                durum: durum,
                serviceName: "urun",
                methodName: "umalzemeDurumGuncelle"

            }
        };
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    ukategoriOpsiyonList(ukategoriId) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                ukategoriId: ukategoriId,
                serviceName: "urun",
                methodName: "ukategoriOpsiyonList"

            }
        };
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    ukategoriOpsiyonAllList(kategoriList) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                kategoriList: kategoriList,
                serviceName: "urun",
                methodName: "ukategoriOpsiyonAllList"

            }
        };
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },
    kategoriOpsiyonAtama(ukategoriId, opsiyonList) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                ukategoriId: ukategoriId,
                opsiyonList: opsiyonList,
                serviceName: "urun",
                methodName: "kategoriOpsiyonAtama"

            }
        };
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    ukategoriMalzemeList(ukategoriId) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                ukategoriId: ukategoriId,
                dil: 'tr',
                serviceName: "urun",
                methodName: "ukategoriMalzemeList"

            }
        };
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    ukategoriMalzemeAllList(kategoriList) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                kategoriList: kategoriList,
                serviceName: "urun",
                methodName: "ukategoriMalzemeAllList"

            }
        };
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    kategoriMalzemeAtama(ukategoriId, malzemeList) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                ukategoriId: ukategoriId,
                malzemeList: malzemeList,
                serviceName: "urun",
                methodName: "kategoriMalzemeAtama"

            }
        };
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    urunListesiArama(durum, arama) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                durum: durum,
                arama: arama,
                serviceName: "urun",
                methodName: "urunListesiArama"

            }
        };
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },

    urunMalzemeArama(durum, arama) {
        var userDataKader = JSON.parse(decodeURI(base64.decode(localStorage.getItem("userDataKader"))));
        var param = {
            data: {
                yonetimId: userDataKader["yonetimId"],
                userToken: userDataKader["token"],
                firmaKodu: userDataKader["firmaKodu"],
                durum: durum,
                arama: arama,
                dil: "tr",
                serviceName: "urun",
                methodName: "urunMalzemeArama"

            }
        };
        var result = new Promise(function(resolve, reject) {
            WsProvider.ajaxPost(serviceName, param).then((response) => {
                resolve(response)
            })
        });
        return result;

    },



}

export default urunService